import PropTypes from 'prop-types';
import React from 'react';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import {CustomMessages} from '../components/CustomMessages';
import SimpleReactValidator from '../components/validator';
import BlockUi from '../components/waitPanel/BlockUi';
import SupeMoyaService from '../services/SupeMoyaRegistrationService';

class SuperMoyaUnsubscribeContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new SupeMoyaService();
        this.state = {
            resultRendered: false,
            resultType: undefined,
            resultMessage: undefined,
        };
        this.validator = new SimpleReactValidator({}, this.translate);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    handleFormSubmit(e) {
        if (e !== undefined) {
            e.preventDefault();
        }
        this.blockUi();
        this.service
            .unsubscribe(this.props.token)
            .then((res) => {
                this.setState({
                    resultType: 'success',
                    resultMessage: 'Twój adres e-mail został usunięty z naszej<br />bazy mailingowej',
                });
                this.unblockUi();
            })
            .catch((err) => {
                this.setState({
                    resultType: 'error',
                    resultMessage: 'Błąd',
                    resultMessageDesc: 'Coś poszło nie tak',
                });
                this.unblockUi();
            });
    }

    render() {
        const {resultMessage, resultType, resultMessageDesc} = this.state;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        {resultType === 'success' || resultType === 'cancel' || resultType === 'error' ? (
                            <div className='app-container'>
                                <div className='title-container'>
                                    <img src='/images/super_moya_logo.svg' className='logo' alt='logo moya' />
                                </div>
                                <div className='title-container'>
                                    {resultType ? (
                                        <img
                                            src={`/images/${
                                                resultType === 'success' || resultType === 'cancel' ? 'success_ico' : 'error_ico'
                                            }.svg`}
                                            className='logo'
                                            alt='result icon'
                                        />
                                    ) : null}
                                </div>
                                <div className='row'>
                                    <div className='title'>
                                        <label className='text' dangerouslySetInnerHTML={{__html: resultMessage}} />
                                    </div>
                                </div>
                                <div className='result-container'>
                                    <span className='text' dangerouslySetInnerHTML={{__html: resultMessageDesc}} />
                                </div>
                            </div>
                        ) : (
                            <div className='app-container'>
                                <div className='title-container'>
                                    <img src='/images/super_moya_logo.svg' className='logo' alt='logo moya' />
                                </div>
                                <div className='title-container'>
                                    <img src={`/images/error_ico.svg`} className='logo' alt='result icon' />
                                </div>
                                <div className='row'>
                                    <div className='title'>
                                        <label className='text'>Na pewno chcesz nas opuścić?</label>
                                    </div>
                                </div>
                                <div className='result-container'>
                                    <span className='text'>
                                        Twój adres e-mail zostanie usunięty z naszej
                                        <br />
                                        listy mailingowej
                                    </span>
                                </div>
                                <div className='footer-container'>
                                    <span className='text'>Co to znaczy?</span>
                                </div>
                                <div className='result-container'>
                                    <span className='text'>
                                        Nie będziesz otrzymywać od nas
                                        <br />
                                        wiadomości e-mail
                                    </span>
                                </div>
                                <div className='button-container'>
                                    <ActionButton
                                        label={'Anuluj'}
                                        variant='cancel-button'
                                        handleClick={() => {
                                            this.setState({
                                                resultType: 'cancel',
                                                resultMessage: 'Cieszymy się, że zdecydowałeś się<br />z nami zostać.',
                                            });
                                        }}
                                    />
                                    <ActionButton label={'Wypisz'} variant='unsubscribe-button' handleClick={this.handleFormSubmit} />
                                </div>
                            </div>
                        )}
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}

SuperMoyaUnsubscribeContainer.propTypes = {
    token: PropTypes.string,
};

export default SuperMoyaUnsubscribeContainer;
